import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionCategoryRow } from "../viewUtils";
import styles from "../Categories.module.scss";

function trimDescription(description: string | null): string {
    if (!description) {
        return "";
    }
    const trimmed = description.trim();
    const commonExamplesIdx = trimmed.indexOf("Common examples:");
    if (commonExamplesIdx === -1) {
        return trimmed;
    }
    return trimmed.slice(0, commonExamplesIdx);
}

export const DescriptionCell = memo(function DescriptionCell({
    row,
}: CellContext<ViewTableFeatures, TransactionCategoryRow, unknown>) {
    const { description } = row.original;

    const trimmed = trimDescription(description);

    if (!trimmed) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <Tooltip
                content={
                    <span style={{ whiteSpace: "pre-line" }}>
                        {description}
                    </span>
                }
            >
                <div className={styles.description}>{trimmed}</div>
            </Tooltip>
        </ViewTableCell>
    );
});
